import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { supabase } from '../../../supabaseClient';
import { alertError } from '../../../components/Toast';

const ReceiptUpload = ({ value, onChange, bucket = 'installment' }) => {
  const company = useSelector((state) => state.app.company || {});
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const companyPrefix = company?.id ? `${company.id}/` : '';
      const path = `receipts/${companyPrefix}${Date.now()}-${file.name}`;
      const { data, error } = await supabase.storage.from(bucket).upload(path, file);

      if (error) {
        alertError('Erro ao enviar comprovante.');
        return;
      }

      setFileName(file.name);
      onChange(data.Key || data.path || path);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFileName('');
    onChange(null);
    if (inputRef.current) inputRef.current.value = '';
  };

  const hasFile = !!value;

  return (
    <div className="fd-form-group">
      <label className="fd-receipt-label">
        Comprovante <span className="fd-receipt-optional">(opcional)</span>
      </label>
      <button
        type="button"
        className={`fd-receipt-upload ${hasFile ? 'fd-receipt-upload--filled' : ''}`}
        onClick={() => inputRef.current?.click()}
        aria-label="Anexar comprovante"
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/*,.pdf"
          style={{ display: 'none' }}
          onChange={handleFileChange}
          aria-label="Selecionar arquivo de comprovante"
        />
        {uploading ? (
          <div className="fd-receipt-placeholder">
            <span className="fd-receipt-icon">⏳</span>
            <span className="fd-receipt-hint">Enviando...</span>
          </div>
        ) : hasFile ? (
          <div className="fd-receipt-preview">
            <span className="fd-receipt-icon">📄</span>
            <div className="fd-receipt-info">
              <div className="fd-receipt-filename">{fileName || 'Comprovante anexado'}</div>
              <button
                type="button"
                className="fd-receipt-remove"
                onClick={handleRemove}
                aria-label="Remover comprovante"
              >
                ✕ Remover
              </button>
            </div>
          </div>
        ) : (
          <div className="fd-receipt-placeholder">
            <span className="fd-receipt-icon">📎</span>
            <span className="fd-receipt-hint">Clique para anexar foto ou arquivo</span>
            <span className="fd-receipt-formats">JPG, PNG, PDF</span>
          </div>
        )}
      </button>
    </div>
  );
};

export default ReceiptUpload;
